(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name message.factory:AlertRequestFactory
     *
     * @description
     *
     */
    angular
        .module('message')
        .factory('AlertRequestFactory', AlertRequestFactory);

    function AlertRequestFactory() {

    	//----declare DTOs------
    	//search Request
        function SearchCriteriaDTO(){
            this.fromDate = null;
            this.toDate = null;
            this.crewBase = null;
            this.crewTypeCode = null;
            this.categoryCode = null;
            this.aircraftType = null;
            this.crewProfileId = null;
            this.searchMethordDate = 'C';
            this.showAllAlerts = false;
            this.pageSize = null;
            this.startPosition = null;
        }

        //alert DTO
        function AlertDTO() {
            this.alertId = null;
            this.version = null;
            this.category = null;
            this.crewTypeCode = null;
            this.crewName = null;
            this.blockOrEvent = null;
            this.msgContent = null;
            this.isHandled = null;
            this.crewProfileId = null;
            this.viewedDate = null;
            this.viewedTime = null;
            this.affectedDutyDate = null;
            this.handledBy = null;
            this.handledDate = null;
            this.handledTime = null;
            this.createdBy = null;
            this.createdDate = null;
            this.createdTime = null;
        }

        //send sms request
        function SendSmsDTO(){
        	this.crewProfileIdList = [];
        	this.content = null;
        	this.hasConfirmation = true;
        	this.confirmationDuration = 0;
        }

        //edit sms panel
        function NewSmsDTO(){
        	this.crewTypeCode = null;
        	this.crewName = null;
        	this.content = null;
        	this.hasConfirmation = true;
        	this.confirmationDuration = 0;
        }

      //send sms request
        function CrewDTO(){
        	this.crewTypeCode = null;
        	this.crewName = null;
        	this.crewProfileId = null;
        }
        //mark as inform request
        function MarkAsInformAlertDTO(){
        	this.alertId = null;
        	this.version = null;
        }//alertCollection

        function MarkAsInformDTO(){
        	this.alertCollection = [];
        }

        //----Define Function --------
        function GetAlertSearchRequest() {
            return new SearchCriteriaDTO();
        }

		function GetFormattedAlertSearchRequest(params) {
			var formattedCriteria = new SearchCriteriaDTO();
            formattedCriteria.fromDate = params.fromDate;
            formattedCriteria.toDate = params.toDate;
            if(!!params.crew && !!params.crew.crewProfileId){
            	formattedCriteria.crewProfileId = params.crew.crewProfileId;
            }
            if(!!params.crewType && !!params.crewType.crewTypeCode){
            	formattedCriteria.crewTypeCode = params.crewType.crewTypeCode;
            }
            if(!!params.crewBase && !!params.crewBase.airPortCode){
            	formattedCriteria.crewBase = params.crewBase.airPortCode;
            }
            if(!!params.alertCategory && !!params.alertCategory.categoryCode){
            	formattedCriteria.categoryCode = params.alertCategory.categoryCode;
            }
            if(!!params.aircraftType && !!params.aircraftType.modelNumber){
            	formattedCriteria.aircraftType = params.aircraftType.modelNumber;
            }
            if(!!params.createdBy){
              var crewIdList = [];
              angular.forEach(params.createdBy, function (crew, key) {
                crewIdList.push(crew.loginId);
              });
              formattedCriteria.createdByList = crewIdList;
            }

          if(!!params.templateCodes){
            var templateCodeList = [];
            angular.forEach(params.templateCodes, function (template, key) {
              templateCodeList.push(template.alertTemplateCode);
            });
            formattedCriteria.alertTemplateCodeList = templateCodeList;
          }
            formattedCriteria.searchMethordDate = params.isAffectedDutyDate?'E':'C';
            formattedCriteria.showAllAlerts = params.isShowAllAlerts? true :false;
            formattedCriteria.pageSize = params.pageSize;
            formattedCriteria.startPosition = params.startPosition
            return formattedCriteria;
        }

        function GetAlertDTO(){
        	return new AlertDTO();
        }
        function GetFormattedAlerts(alerts) {
            var formattedList = [];
            angular.forEach(alerts, function (alert, key) {
                formattedList.push(formatAlert(alert))
            });
            return formattedList;
        }
        function formatAlert(alert) {
            var newAlert = new AlertDTO();
            newAlert = alert;
            return newAlert;
        }

        function GetAlertForEditor() {
            return new AlertDTO();
        }

        function GetSMSSendRequest(){
        	return new SendSmsDTO();
        }

        function GetFormattedSMSSendRequest(param){
        	var formattedSMS = new SendSmsDTO();
        	formattedSMS.crewProfileIdList.push(param.crew.crewProfileId);
        	formattedSMS.content = param.content;
        	formattedSMS.hasConfirmation = param.hasConfirmation;
        	formattedSMS.confirmationDuration = param.confirmationDuration;
        	return formattedSMS;
        }

        function GetNewSMS(){
        	var formattedSMS = new NewSmsDTO();
        	return formattedSMS;
        }

        function GetMarkAsInformRequest(){
        	return new MarkAsInformDTO();
        }

        function GetFormatedMarkAsInformAlertDTO(params){
        	var markAsInformAlertDTO = new MarkAsInformAlertDTO();
        	markAsInformAlertDTO.alertId = params.alertId;
        	markAsInformAlertDTO.version = params.version;
        	return markAsInformAlertDTO;
        }

        function GetMarkAsInformAlertRequest(){
        	return new MarkAsInformAlertDTO();
        }

        function SetSMSRequestForMultipleAlerts(selectedAlerts){
        	var formattedSMS = new SendSmsDTO();
        	if(!!selectedAlerts){
        		for(var i=0;i<selectedAlerts.length;i++){
        			if(!!selectedAlerts[i].crewProfileId && selectedAlerts[i].crewProfileId!=null && selectedAlerts[i].crewProfileId!=""){
                    	formattedSMS.crewProfileIdList.push(selectedAlerts[i].crewProfileId);
                	}
        		}
        	}
        	return formattedSMS;
        }

        //map services to return
        return {
        	getAlertSearchRequest: GetAlertSearchRequest,
            getFormattedAlertSearchRequest: GetFormattedAlertSearchRequest,
            getAlertDTO : GetAlertDTO,
            getFormattedAlerts: GetFormattedAlerts,
            getAlertForEditor : GetAlertForEditor,
            getSMSSendRequest : GetSMSSendRequest,
            getFormattedSMSSendRequest:GetFormattedSMSSendRequest,
            getNewSMS :GetNewSMS,
            getFormatedMarkAsInformAlertDTO:GetFormatedMarkAsInformAlertDTO,
            getMarkAsInformAlertRequest : GetMarkAsInformAlertRequest,
            getMarkAsInformRequest : GetMarkAsInformRequest,
            setSMSRequestForMultipleAlerts : SetSMSRequestForMultipleAlerts
        }

    }
})();
